import React from "react";
import {
  Box,
  Table as CKTable,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { theme } from "src/styles/theme";
import { formatMoney } from "@helpers/format";

type TableRow = {
  idUnidadeSales: string;
  idEmpreendimentoSales: string;
  nomeEmpreendimento: string;
  identificador: string;
  tipoPlanta: string;
  valorFinalKit: number;
  valorAvalBancaria: number;
  bonusAdimplencia: number;
};

interface IDataTable {
  data: TableRow[];
  onClick: () => void;
  searchFilter: string;
  setUnity: React.Dispatch<React.SetStateAction<TableRow>>;
  setIdEnterprises: React.Dispatch<React.SetStateAction<string>>;
}

function TableUnity({
  data,
  onClick,
  searchFilter,
  setUnity,
  setIdEnterprises
}: Readonly<IDataTable>) {
  const filteredRows = React.useMemo(() => {
    if (!data) return [];

    const search = searchFilter.trim().toLowerCase();
    if (!search) return data;

    return data.filter((row) => {
      return (
        row.nomeEmpreendimento?.toLowerCase().includes(search) ||
        row.identificador?.toLowerCase().includes(search) ||
        row.tipoPlanta?.toLowerCase().includes(search)
      );
    });
  }, [data, searchFilter]);

  return (
    <CKTable flexDirection="column" variant="simple" bg="white">
      <Thead
        h="60px"
        position="sticky"
        top="0"
        zIndex="1"
        bg="white"
        boxShadow="sm"
      >
        <Tr>
          <Th w="17%" textAlign="center" color={theme.text}>
            <Box display={"flex"} alignItems={"center"} gap={"4px"}>
              <Text
                alignItems={"center"}
                fontSize={12}
                w={"fit-content"}
                textTransform="capitalize"
              >
                Empreendimento{" "}
              </Text>
            </Box>
          </Th>
          <Th w="17%" textAlign="center" color={theme.text}>
            <Box display={"flex"} alignItems={"center"} gap={"4px"}>
              <Text
                alignItems={"center"}
                fontSize={12}
                w={"fit-content"}
                textTransform="capitalize"
              >
                Identificador{" "}
              </Text>
            </Box>
          </Th>
          <Th w="17%" color={theme.text}>
            <Box display={"flex"} alignItems={"center"} gap={"4px"}>
              <Text
                alignItems={"center"}
                fontSize={12}
                w={"fit-content"}
                textTransform="capitalize"
              >
                Tipo de planta{" "}
              </Text>
            </Box>
          </Th>
          <Th w="17%" textAlign="center" color={theme.text}>
            <Box display={"flex"} alignItems={"center"} gap={"4px"}>
              <Text
                alignItems={"center"}
                fontSize={12}
                w={"fit-content"}
                textTransform="capitalize"
              >
                Valor da unidade
              </Text>
            </Box>
          </Th>
          <Th w="17%" textAlign="center" color={theme.text}>
            <Box display={"flex"} alignItems={"center"} gap={"4px"}>
              <Text
                alignItems={"center"}
                fontSize={12}
                w={"fit-content"}
                textTransform="capitalize"
              >
                Avaliação bancária{" "}
              </Text>
            </Box>
          </Th>
          <Th w="17%" textAlign="center" color={theme.text}>
            <Box display={"flex"} alignItems={"center"} gap={"4px"}>
              <Text
                alignItems={"center"}
                fontSize={12}
                w={"fit-content"}
                textTransform="capitalize"
              >
                Bônus adimplência{" "}
              </Text>
            </Box>
          </Th>
        </Tr>
      </Thead>

      <Tbody>
        {filteredRows?.map((row: TableRow, index) => (
          <Tr
            key={index}
            _hover={{ bg: "#E2E8F0" }}
            cursor={"pointer"}
            onClick={() => {
              onClick();
              setUnity(row)
              setIdEnterprises(row.idEmpreendimentoSales)
            }}
          >
            <Td w="17%" color={theme.text}>
              <Box display={"flex"} alignItems={"center"}>
                <Text w={"fit-content"} fontSize={"13px"} fontWeight={500}>
                  {row?.nomeEmpreendimento}
                </Text>
              </Box>
            </Td>

            <Td w="17%" color={theme.text50}>
              <Box display={"flex"} alignItems={"center"}>
                <Text
                  w={"fit-content"}
                  fontSize={"13px"}
                  textAlign={"center"}
                  pl={"5px"}
                >
                  {row?.identificador}
                </Text>
              </Box>
            </Td>

            <Td w="17%" color={theme.text50}>
              <Box display={"flex"} alignItems={"center"}>
                <Text
                  w={"fit-content"}
                  fontSize={"13px"}
                  textAlign={"center"}
                  pl={"5px"}
                >
                  {row.tipoPlanta}
                </Text>
              </Box>
            </Td>

            <Td w="17%" color={theme.text50}>
              <Box display={"flex"} alignItems={"center"}>
                <Text
                  w={"fit-content"}
                  fontSize={"13px"}
                  textAlign={"center"}
                  pl={"10px"}
                >
                  {formatMoney(row?.valorFinalKit)}
                </Text>
              </Box>
            </Td>

            <Td w="17%" color={theme.text50}>
              <Box display={"flex"} alignItems={"center"}>
                <Text
                  w={"fit-content"}
                  fontSize={"13px"}
                  textAlign={"center"}
                  pl={"10px"}
                >
                  {formatMoney(row?.valorAvalBancaria)}
                </Text>
              </Box>
            </Td>

            <Td w="17%" color={theme.text50}>
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Text w={"fit-content"} fontSize={"13px"} textAlign={"center"}>
                  {formatMoney(row?.bonusAdimplencia)}
                </Text>
              </Box>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </CKTable>
  );
}

export default React.memo(TableUnity);
